'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Modal = require('@cimpress/react-components/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _Spinner = require('@cimpress/react-components/lib/shapes/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _ManyTenantsSelect = require('./ManyTenantsSelect');

var _ManyTenantsSelect2 = _interopRequireDefault(_ManyTenantsSelect);

var _SimpleSelect = require('./SimpleSelect');

var _SimpleSelect2 = _interopRequireDefault(_SimpleSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Maximum number of tenants user has access to that will still show the simplified selector
 */
var MAX_TENANTS_SIMPLE_SELECTOR = 6;

var SelectorDelegator = function SelectorDelegator(props) {
  return props.merchants.length + props.fulfillers.length > MAX_TENANTS_SIMPLE_SELECTOR ? _react2.default.createElement(_ManyTenantsSelect2.default, props) : _react2.default.createElement(_SimpleSelect2.default, props);
};

SelectorDelegator.propTypes = {
  merchants: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired
  })).isRequired,
  fulfillers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired
  })).isRequired
};

var ModalFooter = function ModalFooter(_ref) {
  var onSave = _ref.onSave,
      onClose = _ref.onClose,
      mustSelectTenant = _ref.mustSelectTenant,
      canSave = _ref.canSave;
  return _react2.default.createElement(
    'div',
    { className: 'pull-right' },
    _react2.default.createElement(
      'button',
      { className: 'btn btn-default', disabled: mustSelectTenant, onClick: onClose },
      'Cancel'
    ),
    _react2.default.createElement(
      'button',
      { className: 'btn btn-primary', disabled: !canSave, onClick: onSave },
      'Save'
    )
  );
};

ModalFooter.propTypes = {
  onSave: _propTypes2.default.func.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  mustSelectTenant: _propTypes2.default.bool.isRequired,
  canSave: _propTypes2.default.bool.isRequired
};

var SelectorModal = function SelectorModal(_ref2) {
  var mustSelectTenant = _ref2.mustSelectTenant,
      selectedTenant = _ref2.selectedTenant,
      show = _ref2.show,
      loading = _ref2.loading,
      onClose = _ref2.onClose,
      title = _ref2.title,
      helpText = _ref2.helpText,
      props = _objectWithoutProperties(_ref2, ['mustSelectTenant', 'selectedTenant', 'show', 'loading', 'onClose', 'title', 'helpText']);

  return _react2.default.createElement(
    _Modal2.default,
    {
      show: show || mustSelectTenant,
      title: title,
      onRequestHide: onClose,
      closeButton: !mustSelectTenant,
      footer: _react2.default.createElement(ModalFooter, _extends({ mustSelectTenant: mustSelectTenant, onClose: onClose, loading: loading }, props)) },
    helpText && _react2.default.createElement(
      'p',
      { style: { marginBottom: '40px' } },
      helpText
    ),
    loading ? _react2.default.createElement(_Spinner2.default, { className: 'text-center' }) : _react2.default.createElement(SelectorDelegator, _extends({ selectedTenant: selectedTenant }, props))
  );
};

SelectorModal.propTypes = {
  mustSelectTenant: _propTypes2.default.bool.isRequired,
  selectedTenant: _propTypes2.default.string,
  show: _propTypes2.default.bool.isRequired,
  loading: _propTypes2.default.bool.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  title: _propTypes2.default.string.isRequired,
  helpText: _propTypes2.default.string
};

SelectorModal.defaultProps = {
  selectedTenant: undefined
};

exports.default = SelectorModal;
//# sourceMappingURL=SelectorModal.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cimpress-technology/react-platform-tenant-selector/lib/components/tenant/SelectorModal.js
// module id = 517
// module chunks = 0